import projectCenter from "../../api/projectCenter";

const state = {
    evaluationListFilter: {},
    evaluationListLoading: false,
    evaluationList: {},
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async saveEvaluation({commit}, payload) {
        return await projectCenter.post(projectCenter.url.SAVE_EVALUATION, payload)
    },
    // eslint-disable-next-line no-empty-pattern
    async getEvaluationList({commit}, payload) {
        commit("setData", {key: "evaluationListLoading", value: true});
        try {
            const params = {
                ...state.evaluationList.size,
                ...state.evaluationList.page,
                ...state.evaluationListFilter,
                ...payload,
            };
            const res = await projectCenter.getEvaluationList.getList(params);
            commit("setData", {key: "evaluationList", value: res.data});
        } finally {
            commit("setData", {key: "evaluationListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteEvaluation({commit}, payload) {
        return await projectCenter.post(projectCenter.url.DELETE_EVALUATION, payload)
    },
    // eslint-disable-next-line no-empty-pattern
    async getProjectUserList({commit}, payload) {
        return await projectCenter.post(projectCenter.url.GET_PROJECT_USER_LIST, payload)
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
